module.exports = "<h1 mat-dialog-title>Process metadata</h1>\n<div mat-dialog-content>\n  <pre>{{ process | json }}</pre>\n</div>\n"